import { render, staticRenderFns } from "./SWFollowListItem.vue?vue&type=template&id=1dc5c74c&scoped=true"
import script from "./SWFollowListItem.vue?vue&type=script&lang=js"
export * from "./SWFollowListItem.vue?vue&type=script&lang=js"
import style0 from "./SWFollowListItem.vue?vue&type=style&index=0&id=1dc5c74c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc5c74c",
  null
  
)

export default component.exports